var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9719 9.83892L7.59 2.26439C7.38125 2.13656 7.14215 2.06678 6.89741 2.06225C6.65267 2.05772 6.41116 2.1186 6.19781 2.23861C5.9865 2.35676 5.81047 2.52906 5.68783 2.7378C5.56518 2.94653 5.50035 3.18417 5.5 3.42627V18.5736C5.50159 18.9368 5.64733 19.2844 5.90516 19.5402C6.163 19.7959 6.51184 19.9388 6.875 19.9374C7.12847 19.9373 7.37703 19.8675 7.59344 19.7355L19.9719 12.161C20.1708 12.0397 20.3353 11.8693 20.4494 11.6661C20.5635 11.4629 20.6234 11.2338 20.6234 11.0008C20.6234 10.7678 20.5635 10.5387 20.4494 10.3355C20.3353 10.1323 20.1708 9.96192 19.9719 9.84064V9.83892ZM6.875 18.5573V3.43744L19.2354 10.9999L6.875 18.5573Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.abab7ff96619babe07c5b11b574cbbbb.svg";
export { ForwardRef as ReactComponent };